import { ApiClient } from '@/config/axios.config';
import type { BunkerPrice, BunkerPriceHistory, HistoricalPeriod } from '@/types/bunkerPrices.types';

export class BunkerPricesService {
  private static readonly BASE_PATH = '/bunkerprices';

  /**
   * Fetch all current bunker prices
   */
  static async getBunkerPrices(): Promise<BunkerPrice[]> {
    try {
      return await ApiClient.get<BunkerPrice[]>(this.BASE_PATH);
    } catch (error) {
      console.error('Failed to fetch bunker prices:', error);
      throw error;
    }
  }

  /**
   * Fetch historical bunker prices for a specific port and period
   * Period values: 0=Daily, 1=Weekly, 2=Monthly, 3=Yearly
   */
  static async getBunkerPricesHistory(
    portId: number,
    period: HistoricalPeriod
  ): Promise<BunkerPriceHistory[]> {
    try {
      // Convert enum to string for the API (Daily, Weekly, Monthly, Yearly)
      const periodMap = ['Daily', 'Weekly', 'Monthly', 'Yearly'];
      const periodString = periodMap[period];
      return await ApiClient.get<BunkerPriceHistory[]>(
        `${this.BASE_PATH}/history/${portId}/${periodString}`
      );
    } catch (error) {
      console.error('Failed to fetch bunker price history:', error);
      throw error;
    }
  }
}
